import { SelectBoxOpt } from '@/components/content/SelectBox'
import { OutboundScheduleShipperCode } from './types/query'

export const PLATFORM_OPTIONS: SelectBoxOpt<OutboundScheduleShipperCode>[] = [
  { label: 'MUSINSA', value: 'MUSINSA' },
  { label: '29CM', value: '29CM' },
  { label: 'MUSINSA_USED', value: 'MUSINSA_USED' },
]

// 출고지시 on/off 토글(cell) 기능 사용 여부 — false면 토글 비노출(disabled)
export const OUTBOUND_INSTRUCTION_TOGGLE_ENABLED: boolean = false

// 출고대기시간 변경 허용 email 화이트리스트 — 미포함 사용자는 "출고대기시간 변경" 옵션 미노출 (실제 권한 검증은 BE)
// yongsub.kim, gyoungjun.lee는 개발/QA용 임시 — LOGISPRD-8570에서 제거 예정
export const WAIT_TIME_EDIT_ALLOWED_EMAILS = [
  'hwan@musinsa.com',
  'daehwan.ryu@musinsa.com',
  'sm.park@musinsa.com',
  'nara.shin@musinsa.com',
  'sookeun.woo@musinsa.com',
  'yongsub.kim@musinsa.com',
  'gyoungjun.lee@musinsa.com',
  'seoyun.lee@musinsa.com',
  'lina.choi@musinsa.com',
  'hyeyoung.lee@musinsa.com',
  'sookeun.woo@musinsa.com',
]

// ─── Layout ─────────────────────────────────────────────────
export const CELL_WIDTH = 180
export const TIME_CELL_WIDTH = 130
export const WAIT_TIME_CELL_WIDTH = 110
// H+M 혼합 표기('1H 10M', '8H 50M' 등)는 글자 수가 더 많아 셀 너비를 확장
export const WAIT_TIME_CELL_WIDE_WIDTH = 130
// 본문 슬롯들의 waitTime 중 하나라도 분 포함 표기일 때 sticky 영역 확장
export const LEFT_STICKY_WIDTH = TIME_CELL_WIDTH + WAIT_TIME_CELL_WIDTH // 240
export const LEFT_STICKY_WIDE_WIDTH = TIME_CELL_WIDTH + WAIT_TIME_CELL_WIDE_WIDTH // 260

/** 이 화면의 2.0 화면코드 — 같이 쓰는 수용량 API 에 X-Menu-Code 로 실어 감사 로그 MENU_CD 를 가른다(LOGISPRD-15645) */
export const MENU_CODE = 'GI28'
